var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupidAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5303 2.53033C22.8232 2.23744 22.8232 1.76256 22.5303 1.46967C22.2374 1.17678 21.7626 1.17678 21.4697 1.46967L18.6611 4.27824C16.7273 3.57671 14.2397 4.16877 12 6.43111C7.50016 1.88586 2 4.08262 2 9.96653C2 12.3728 3.87615 14.8739 6.00316 16.9362L2.75 20.1893V18C2.75 17.5858 2.41421 17.25 2 17.25C1.58579 17.25 1.25 17.5858 1.25 18V22.75H6C6.41421 22.75 6.75 22.4142 6.75 22C6.75 21.5858 6.41421 21.25 6 21.25H3.81066L7.10793 17.9527C7.74176 18.5079 8.37329 19.0177 8.96173 19.4687C10.2937 20.4896 10.9597 21 12 21C13.0403 21 13.7063 20.4896 15.0383 19.4687C17.9806 17.2137 22 13.4887 22 9.9665C22 7.75156 21.2206 6.05913 20.0085 5.05214L22.5303 2.53033ZM7.10793 17.9527C6.73775 17.6285 6.36679 17.2887 6.00316 16.9362L11.4697 11.4697C11.7626 11.1768 12.2374 11.1768 12.5303 11.4697C12.8232 11.7626 12.8232 12.2374 12.5303 12.5303L7.10793 17.9527Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupidAlt);
export default __webpack_public_path__ + "static/media/cupid-alt.1fbdaeb1c3f6c3154eeafb12f2e3e3c9.svg";
export { ForwardRef as ReactComponent };